import produce from "immer"
import { ASC } from "const"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

const initTaskParticipantState: types.TaskParticipantState = {
    taskParticipantList: null,

    notAssignedUsers: {
        userIds: null,
        sortColumn: "firstName",
        sortOrder: ASC,
        filters: {
            status: null,
            search: null,
        },
        selected: null,
    },
}

const taskParticipantReducer = produce((
    draft: types.TaskParticipantState = initTaskParticipantState,
    action: ActionTypes = null,
): types.TaskParticipantState => {
    switch (action.type) {
        case types.TASK_PARTICIPANT_LIST:
            draft.taskParticipantList = action.taskParticipantList
            return draft

        case types.NOT_ASSIGNED_TASK_PARTICIPANT_IDS:
            draft.notAssignedUsers.userIds = action.userIds
            return draft

        case types.NOT_ASSIGNED_TASK_PARTICIPANT_SORT:
            draft.notAssignedUsers.sortColumn = action.sortColumn
            draft.notAssignedUsers.sortOrder = action.sortOrder
            return draft

        case types.NOT_ASSIGNED_TASK_PARTICIPANT_FILTERS:
            draft.notAssignedUsers.filters = action.filters
            return draft

        case types.NOT_ASSIGNED_TASK_PARTICIPANT_SELECTED:
            draft.notAssignedUsers.selected = action.selected
            return draft

        default:
            return draft
    }
})
export default taskParticipantReducer
